import React from 'react';
import './Board.css'; // Ensure you have the necessary CSS for styling
import board from './image/Board.svg';
import frame from './image/Frame.svg';

// Importing all images (assuming they are in the 'image' folder)
import img1 from './image/1.webp';
import img2 from './image/2.jpg';
import img3 from './image/3.jpeg';
import img4 from './image/4.jpeg';
import img5 from './image/5.jpg';
import img6 from './image/6.jpg';
import img7 from './image/7.jpg';
import img8 from './image/8.jpeg';
import img10 from './image/10.jpeg';

const Board = () => {
  const officers = [
    { name: 'Dr. Rajan Weukar', title: 'President', img: img1 },
    { name: 'Arvind Ballal', title: 'Vice-President', img: img2 },
    { name: 'Dyaneshwar Mundhe', title: 'Vice-President', img: img3 },
    { name: 'Mr. Eknath Tambvekar', title: 'Vice-President', img: img4 },
    { name: 'Mr. R.K Gaikwad', title: 'Executive Chairman', img: img5 },
    { name: 'Varsha Vidya Vilas', title: 'General Secretary', img: img6 },
    { name: 'Mr. Anil Hebbar', title: 'Treasurer', img: img7 },
    { name: 'Mr. Amol Madame', title: 'Secretary', img: img10 },
    { name: 'Mr. Chandrakant Choudhari', title: 'Secretary', img: img8 },
  ];

  return (
    <div className="board-container">
      <img src={frame} alt="Board of Officers" className="board-title" />
      <div className="officers-grid">
        {officers.map((officer, index) => (
          <div key={index} className={`officer-card officer-card-${index + 1}`}>
            <div className={`frame-container frame-container-${index + 1}`}>
              <img
                src={board}
                alt="Frame"
                className={`frame frame-${index + 1}`}
              />
              <img
                src={officer.img}
                alt={officer.name}
                className={`officer-photo officer-photo-${index + 1}`}
              />
            </div>
            <div className={`officer-info officer-info-${index + 1}`}>
              <p className={`officer-name officer-name-${index + 1}`}>
                {officer.name}
              </p>
              <p className={`officer-title officer-title-${index + 1}`}>
                {officer.title}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="commitee">
        
      </div>
    </div>
  );
};

export default Board;
